/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPropertyMarketValue = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12 .78 11 7.698V14h-2V9.52l-9-6.3-9 6.299v11.479l10 .001v2H1V8.479zM17 13a4 4 0 0 1 3.447 6.031l2.26 2.262-1.414 1.414-2.26-2.261A4 4 0 1 1 17 13zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPropertyMarketValue as PropertyMarketValue };
